export default __webpack_public_path__ + "static/charles-wagner-c1ae252c7dd5cead3fa7d7ffda644261.png";